import { t } from "i18next";
import { SelectInputData, SelectInputField } from "../../../../../components/deprecated/SelectInputField/SelectInputField";
import { TextInputField } from "../../../../../components/deprecated/TextInputField/TextInputField";

import { PropertyJointCostSuffix } from "../../../Property/PropertyJointCostSuffix";
import { DataObjectFieldComparator } from "../../DataObjects/DataObjectFieldComparator";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { FirebaseInfoField } from "../../FirebaseInfoField";

import { DataObjectField, DecodeStringContext, InputElementContext } from "../DataObjectField";
import styles from "../DataObjectField.module.css";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";
import { LocalData } from "../../LocalData";

export class PropertyDataFloorsField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<number, FirebaseDataType> {
  hasCustomOptionOrder = true;

  override getValueForKey(key: string): number | undefined {
    return !isNaN(parseInt(key)) ? parseInt(key) : undefined;
  }
  override getOptions(context?: InputElementContext): FirebaseDataSelectFieldOption[] {
    const property = LocalData.properties.getData(context?.propertyID);
    let floors = property?.floors && Array.isArray(property.floors.value) ? property.floors.value : [];
    if (floors.length === 0) floors = [-5, -4, -3, -2, -1, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

    return floors.map((floor) => {
      return {
        key: floor + "",
        label: floor + "",
      };
    });
  }
  override convertValueToSelectInput(value: number): SelectInputData {
    return new SelectInputData(value + "", value + "");
  }
  override getReadableStringRepresentation(value: number): string {
    if (value === -1) return t("main.basement");
    return value + ". " + t("main.floor");
  }

  override encode = (value: number) => value;

  override loadAllDatas(context?: InputElementContext): Promise<void> {
    const property = LocalData.properties.getData(context?.propertyID);
    if (property && !property.infoFieldsLoaded) {
      return new Promise((resolve) => property.loadInfoFields(resolve));
    }
    return Promise.reject();
  }

  override isValueValid = (value: any): boolean => {
    return !isNaN(value) && value !== undefined && typeof value === "number";
  };

  override decodeStringAsRawValue = () => true;
}
export class FirebaseInfoFieldField<FirebaseDataType extends DataObjectType> extends DataObjectField<FirebaseInfoField<any>, FirebaseDataType> {
  encodeString = (value: FirebaseInfoField<any>) => {
    return "" + value.value;
  };
  decodeString = (value: string, context?: DecodeStringContext | undefined) => {
    const obj = new FirebaseInfoField(value);
    return obj;
  };
  encode = (value: FirebaseInfoField<any>) => {
    const encoded: { value: any; suffix?: string } = { value: value.value };
    if (typeof value.suffix === "string") encoded.suffix = value.suffix;
    return encoded;
  };
  decode = (value: any) => {
    if (value instanceof FirebaseInfoField) return value;
    if (typeof value === "object") {
      return new FirebaseInfoField(value.value, typeof value.suffix === "string" ? value.suffix : undefined);
    }
    return new FirebaseInfoField(undefined);
  };
  getReadableStringRepresentation(value: FirebaseInfoField<any>): string {
    const suffix = value.suffix ? " " + value.suffix : "";
    return value.value + suffix;
  }
  allComparators: DataObjectFieldComparator[] = [];

  override isValueValid = (value: any): boolean => {
    return value instanceof FirebaseInfoField;
  };
}

export class PropertyDataJointCostField<FirebaseDataType extends DataObjectType> extends FirebaseInfoFieldField<FirebaseDataType> {
  fullEncode = (value: FirebaseInfoField<any> | FirebaseInfoField<any>[]) => {
    return value;
  };

  singleInputElement = (
    value: FirebaseInfoField<any> | undefined,
    setValue: (value: FirebaseInfoField<any> | undefined) => void,
    context?: InputElementContext
  ) => {
    let jointCostSuffixes = [PropertyJointCostSuffix.PERCENTAGE, PropertyJointCostSuffix.PERSQM, PropertyJointCostSuffix.PERSQFT];
    let selected: PropertyJointCostSuffix = PropertyJointCostSuffix.PERCENTAGE;
    if (value?.suffix) selected = PropertyJointCostSuffix.getSuffixWithId(value.suffix);

    return (
      <div className={styles.jointCostContainer} style={{ width: context?.width }}>
        <TextInputField
          className={styles.textField}
          value={value?.value !== undefined ? value.value + "" : ""}
          placeholder={t("main.fillIn")}
          onChange={(text) => {
            const newValue = parseInt(text);
            if (!isNaN(newValue)) setValue({ loaded: true, ...value, value: newValue, visibility: ["landlordAdmin"] });
            else setValue(undefined);
          }}
          width="100%"
        />
        <SelectInputField
          onChange={(data) => {
            if (data && data instanceof SelectInputData) {
              setValue({ loaded: true, value: value?.value, suffix: data.value, visibility: ["landlordAdmin"] });
            } else {
              setValue({ loaded: true, value: value?.value, suffix: PropertyJointCostSuffix.PERCENTAGE.id, visibility: ["landlordAdmin"] });
            }
          }}
          marginTop={0}
          value={selected.id}
          options={jointCostSuffixes.map((option) => new SelectInputData(option.id, option.name))}
          width="100px"
          className={styles.selectInput}
          menuPortalTarget={context?.menuPortalTarget}
        />
      </div>
    );
  };
}
